module.exports = __webpack_public_path__ + "static/img/lg-archive-img-01@t.a3b1bab.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-archive/lg-archive-img-01@t.jpg
// module id = 1M//
// module chunks = 0